import React from "react";

import { useAuthenticator } from "@aws-amplify/ui-react";
import { Flex, Img, Text, Menu, MenuButton, MenuList, MenuItem, IconButton, Divider } from "@chakra-ui/react";
import { Link } from "react-router-dom";

import arupRedLogo from "assets/images/arup_red.svg";
import { useAppSelector } from "store/store";

export const Topbar: React.FC = () => {
	const { signOut } = useAuthenticator((context) => [context.signOut]);
	const userEmail = useAppSelector((state) => state.user.userEmail);
	const firstName = userEmail ? userEmail[0].toUpperCase() : "";

	return (
		<Flex
			width="100%"
			height="3rem"
			backgroundColor="pureWhite"
			alignItems="center"
			justifyContent="space-between"
			padding="0 2rem"
			zIndex="3"
		>
			<Flex as={Link} to={"/"}>
				<Text ml="1rem" pt=".15rem" fontFamily="heading">
					Gestor de Activos
				</Text>
			</Flex>
			<Flex alignItems="center" gap="1rem">
				<Img src={arupRedLogo} alt="Arup Red Logo" />
				<Menu>
					<MenuButton
						as={IconButton}
						aria-label="Perfil de usuario"
						icon={
					<Flex
						w="1.75rem"
						h="1.75rem"
						borderRadius="full"
						bg="green.500"
						alignItems="center"
						justifyContent="center"
					>
						<Text fontSize="0.85rem" fontWeight="bold" color="white">
							{firstName || "?"}
						</Text>
					</Flex>
				}
						variant="ghost"
						size="sm"
						borderRadius="full"
					/>
					<MenuList>
						{userEmail && (
							<>
								<MenuItem isDisabled fontSize="sm" color="gray.500">
									{userEmail}
								</MenuItem>
								<Divider />
							</>
						)}
						<MenuItem onClick={signOut} color="red.500">
							Cerrar sesión
						</MenuItem>
					</MenuList>
				</Menu>
			</Flex>
		</Flex>
	);
};
